import React, { useState } from "react";
import First from '../../assets/images/home/thirdSection/3.jpg';
import { ArrowRight } from "react-feather";
import MyInput from "../Input/MyInput";
import Button from "../Button/Button";
import Service from "../../Service/Service";



const ContactForm=props=>{

    const [name,setName]=useState();
    const [email,setEmail]=useState();
    const [phone,setPhone]=useState();
    const [subject,setSubject]=useState();
    const [message,setMessage]=useState();
    const [toast,showToast]=useState(false)
    const [error,setError]=useState('')

    const submit=()=>{
        if(!name){
            setError('Please Enter Name');
            showToast(true);
            setTimeout(()=>{showToast(false);},4000)
            return;
          }
          if(!email){
            setError('Please Enter Email');
            showToast(true);
            setTimeout(()=>{showToast(false);},4000)
            return;
          }
          if(!phone){
            setError('Please Enter Phone no');
            showToast(true);
            setTimeout(()=>{showToast(false);},4000)
            return;
          }
          if(!subject){
            setError('Please Enter Subject');
            showToast(true);
            setTimeout(()=>{showToast(false);},4000)
            return;
          }
          if(!message){
            setError('Please Enter Message');
            showToast(true);
            setTimeout(()=>{showToast(false);},4000)
            return;
          }
        let params={
            name,
            email,
            phone,
            subject,
            message
        }
        Service.addContact(params).then(response=>{
          document.getElementById('my_modal_5').showModal()
        }).catch(err=>{
            console.log(err)
        })
    }


    return(
        <div className="mb-0">
                  {
          toast && <div className="absolute z-[100]">
          <div className="toast toast-top toast-end">
    <div className="alert alert-info bg-secondary">
      <span className="text-white text-lg">{error}</span>
    </div>
          </div>
  
    
  </div>
        }

            <div className='flex flex-wrap'>
                {/* Header Section with Gradient */}
                <div className='w-full bg-gradient-to-r from-secondary to-navy-800 px-4 py-6 md:px-8 md:py-8'>
                    <h2 className='text-white text-2xl md:text-4xl font-bold tracking-[1px] mb-2'>
                        CONTACT US
                    </h2>
                    <p className='text-navy-100 text-sm md:text-base mb-0 tracking-[2px] md:tracking-[4px]'>
                        Fill The Form Below
                    </p>
                </div>

                {/* Form Section */}
                <div className='w-full flex items-center justify-center px-4 py-6 md:px-8 md:py-8 pb-8 md:pb-8 bg-white'>
                    <div className="w-full max-w-2xl">
                        <div className="flex flex-col gap-4 md:gap-5">
                            <div className="relative">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Name</label>
                                <input
                                    type="text"
                                    placeholder='Enter your name'
                                    onChange={(e)=>setName(e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-navy-200 transition-all duration-200 text-gray-700 placeholder-gray-400"
                                />
                            </div>
                            <div className="relative">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                                <input
                                    type="email"
                                    placeholder='Enter your email'
                                    onChange={(e)=>setEmail(e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-navy-200 transition-all duration-200 text-gray-700 placeholder-gray-400"
                                />
                            </div>
                            <div className="relative">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
                                <input
                                    type="tel"
                                    placeholder='Enter your phone number'
                                    onChange={(e)=>setPhone(e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-navy-200 transition-all duration-200 text-gray-700 placeholder-gray-400"
                                />
                            </div>
                            <div className="relative">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Subject</label>
                                <input
                                    type="text"
                                    placeholder='Enter subject'
                                    onChange={(e)=>setSubject(e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-navy-200 transition-all duration-200 text-gray-700 placeholder-gray-400"
                                />
                            </div>
                            <div className="relative">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Message</label>
                                <textarea
                                    placeholder='Enter your message'
                                    onChange={(e)=>setMessage(e.target.value)}
                                    rows={5}
                                    className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-navy-200 transition-all duration-200 text-gray-700 placeholder-gray-400 resize-none"
                                />
                            </div>
                        </div>
                        
                        <button 
                            className="w-full mt-6 mb-4 px-6 py-3 bg-secondary hover:bg-navy-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]" 
                            onClick={submit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
                {/* Map for 32 IT tower, Link road model town, Lahore - uncomment and use embed from Google Maps if needed
                <div className='w-full flex justify-end lg-1:w-1/2'>
                <iframe src={`https://maps.google.com/maps?q=${encodeURIComponent('32 IT tower, Link road model town, Lahore')}&output=embed&z=15`} title="32 IT tower, Link road model town, Lahore" width="100%" height="100%" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div> */}

            </div>

            <dialog id="my_modal_5" className="modal backdrop-blur-sm">
              <div className="modal-box w-11/12 max-w-md bg-white rounded-2xl shadow-2xl p-0 overflow-hidden">
                <form method="dialog">
                  <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 text-gray-600 hover:bg-gray-100 z-10" onClick={()=>{window.location.reload()}}>✕</button>
                </form>
                <div className="px-6 py-8 md:px-8 md:py-10 text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">Contact Submitted!</h3>
                  <p className="text-gray-600 mb-6">Thank you for contacting us. We'll get back to you soon.</p>
                  <button 
                    className="px-6 py-2 bg-secondary hover:bg-navy-700 text-white font-semibold rounded-lg transition-all duration-300"
                    onClick={()=>{window.location.reload()}}
                  >
                    Close
                  </button>
                </div>
              </div>
              <form method="dialog" className="modal-backdrop">
                <button>close</button>
              </form>
            </dialog>            
        </div>
    )
}
export default ContactForm
